<div class="ogloginpage" id="login-block">

    <div class="loginwrap">
        <div class="oglogo">
            <img src="../../../assets/img/logo.svg" alt="">

        </div>
        <div class="logincolumn">
            <div class="forgotcolumn">

                <h3>
                    Reset <strong> Password</strong>
                </h3>
                <form [formGroup]="forgotPasswordForm">
                    <div class="formGroup">
                        <label for="">{{labelName.newpassword}}</label>
                        <div class="viewhide">
                            <svg *ngIf="!(hidePsw)" (click)="onChangePswType()">
                                <use xlink:href="assets/img/sprite.svg#openedeye"></use>
                            </svg>
                            <svg *ngIf="(hidePsw)" (click)="onChangePswType()">
                                <use xlink:href="assets/img/sprite.svg#closedeye"></use>
                            </svg>
                            <input [type]="( hidePsw ? 'password': 'text')" formControlName="newpassword" #appAutoFocus
                                (input)="ValidateNewPass(forgotPasswordForm.get('newpassword')?.value)"
                                class="form-control" placeholder="Enter New Password">
                                <!-- <div *ngIf="submitted && forms.value.validationmsg !=''" class="error-message">
                                    {{forms.value.validationmsg}}
                                </div> -->
                        </div>
                    </div>
                    <div class="formGroup">
                        <label for="">Confirm Password</label>
                        <div class="viewhide">

                            <input type="password" formControlName="confirmpassword" class="form-control"
                                [ngClass]="{'is-invalid': submitted && f['confirmpassword'].errors}"
                                (input)="confirmPassword()"

                                placeholder="Confirm Password">
                        </div>
                    </div>
                    <ul class="ticklist">
                        <li [class.red]="minLength" [class.green]="!minLength">Minimum length should be at least 8</li>
                        <li [class.red]="patternMissmatch" [class.green]="!patternMissmatch">Must contain at least one letter and
                        one number</li>
                        <li [class.red]="palindrome" [class.green]="!palindrome">Must not be a palindrome</li>
                        <li [class.red]="isConsecutiveOK" [class.green]="!isConsecutiveOK">Must not contain any character more than
                        twice consecutively</li>
                        <li [class.red]="containsUserName" [class.green]="!containsUserName">Must not have 5 consecutive characters
                        from username</li>
                        <li [class.red]="mustMatch" [class.green]="!mustMatch">Password must match</li>

                    </ul>
                    <!-- <p>
                        Type the character you see in the picture below
                    </p> -->
                    <div class="formGroup">
                            <!-- <ngx-captcha  [config]="captchaConfig"></ngx-captcha> -->
                            <!-- <div class="captcha-container">
                                    <canvas id="captcahCanvas" width="316" height="80"></canvas>
                                    
                                
                                </div> -->
                        <!-- <label for="">Confirm Password</label> -->
                        <!-- <input type="password" name="" id=""> -->
                    
                    </div>
                    <div class="sendemail twobtns">
                            <button class="newlogbtn cancel">cancel</button>
                        <!-- <button class="newlogbtn">Chnage Password</button> -->
                        <button type="submit" class="newlogbtn"
                            (click)="onSubmit()">{{labelButtons.change_password}}</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>



<!-- 
<div class="login-container" id="login-block">
    <div class="loginBox">
        <h3>{{labelName.header}}</h3>

        <form [formGroup]="forgotPasswordForm">
            <div class="formGroup">
                <label>{{labelName.newpassword}}</label>
                <input [type]="( hidePsw ? 'password': 'text')" formControlName="newpassword" class="form-control" 
                [ngClass]="{'is-invalid': submitted && f.newpassword.errors}"
                placeholder="Enter New Password">
                <svg style="left: 28rem !important;" (click)="onChangePswType()">
                    <use xlink:href="assets/img/sprite.svg#eyeview"></use>
                </svg>
            </div>
            <div class="formGroup">
                <label>{{labelName.confirmpassword}}</label>
                <input type="password" formControlName="confirmpassword" class="form-control" 
                [ngClass]="{'is-invalid': submitted && f.confirmpassword.errors}"
                placeholder="Confirm Password">
            </div>
            <div class="logibButton" style="justify-content:flex-end;">   
                <button type="submit" class="btn btn--green" (click)="onSubmit()">{{labelButtons.change_password}}</button>
            </div>
            </form>           
    </div>
</div> -->